const initialState = {
  loading: false,
  genres: [],
  error: "",
};

const genreReducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case "GENRE_FETCH_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "GENRE_FETCH_SUCCESS":
      return {
        loading: false,
        genres: payload,
      };

    case "GENRE_FETCH_FAILURE":
      return {
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default genreReducer;
